<template>
    <router-link :to="'/' + history.details.contentType + '/' + history.id" class="history" v-ripple :class='size'>

    <img class="poster" :src="img" v-on:load="onLoaded" v-on:error="getImage" v-show="loaded" />

    <img v-if="logo" :src="logo" class="logo"/>

      <div v-if='history.details.contentType == "tv"'>
          <span>
              <small><b>SEASON</b> {{history.details.season}}</small>
              <small><b>EPISODE</b> {{history.details.episode}}</small>
          </span>
      </div>
    </router-link>
</template>

<script>

export default {
  name: 'history',
  props: {
    history: Object,
    size: {
        type: String,
        default: function(){ return ''}
    }
  },

  computed: { },

  data: function(){
      return {
            img: 'http://fail.fail.jpg',
            loaded: false,
            notIdeal: false,
            logo: null,
            loader: false,
            allfailed: false,


        }
  },

  methods: {
  async makeImage(){
        try{
            const req = await window.afetch(`/logo?id=${this.history.id}&type=${this.history.details.contentType}`)
            const res = await req.json()
                this.img = this.history.logos[1]
                if(res.logo && res.logo !== ''){
                    this.logo =  res.logo
                }else{
                    this.allfailed = true
                }

            }catch(e){
                this.allfailed = true
            }
        },
        async getImage(){
            try{
                const req = await window.afetch(`/thumbnail?id=${this.history.id}&type=${this.history.details.contentType}`)
                const res = await req.json()

                if(res.url){
                    this.img = res.url
                }else{
                    this.makeImage()
                }
            }catch(e){
                this.makeImage()
            }
        },

        onLoaded: async function() {
            this.loaded = true;
        },

  },

  mounted: function(){
  }
}
</script>

<style scoped lang="scss">
.history{
    display: block;
    position: relative;
    border-radius: 8px;
    margin-right: 20px;
    background-size: cover;
    background-position: center;
    width: 300px;
    height: 200px;
    color: white;
    overflow: hidden;
    .logo{
        text-align: center;
        color: white;
        font-weight: bold;
        font-size: 23px;
        text-transform: uppercase;
        position: absolute;
        bottom: 12px;
        left: 10%;
        width: 80%;
        height: auto;
    }
    .poster{
        border-radius: 12px;
        width: 100%;
        min-height: 100%;
        height: auto;
        object-fit: cover;
    }

    div{
        display: flex;
        position: absolute;
        top: 0;
        width: 100%;
        padding: 5px 10px;
        box-sizing: border-box;
        justify-content: center;
        flex-direction: column;
        text-shadow: 0px 5px 14px #0b0b0b;
        p{
            margin: 0;
        }
        small{
            font-size: 9px;
            margin-right: 10px;
            b{
                font-weight: bold;
                letter-spacing: 1px;
                color: red;
            }
        }
    }
}
</style>
